import { apiClient } from '../../plugins/api'
import { SUGGEST_REQUEST } from '../actions/city'

const state = {
};

const getters = {
};

const actions = {
    async [SUGGEST_REQUEST] ({ commit }, searchParams) {
        const response = await apiClient().get('/city/suggest?term=' + searchParams.term);
        return response.data.cities;
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
